import type { JSX } from 'solid-js';
import PageHead from '@components/seo/PageHead';

export default function HomeRoute(): JSX.Element {
  return (
    <section class="px-4 sm:px-6 py-12 sm:py-16 max-w-6xl mx-auto">
      <PageHead
        title="Terp Track &ndash; Dial in your relief"
        description="Search UK medical cannabis by symptom, track your sessions, and correlate vape temperature with real relief &ndash; anonymised for patients."
        canonical="/"
      />
      <h1 class="font-display text-3xl sm:text-4xl md:text-5xl font-bold leading-tight max-w-xl">
        Dial In Your Relief:
        <br />
        Track Terpenes That Work For You.
      </h1>
      <p class="mt-6 max-w-lg text-brand-green/80">
        Search by symptom, log your sessions, and correlate vape temperature with real relief &ndash; anonymised for the UK Medical Cannabis Community.
      </p>
      <div class="mt-8 flex flex-wrap gap-3">
        <a
          href="/diary"
          class="inline-block px-6 py-3 rounded-full bg-brand-green text-brand-cream font-medium hover:bg-brand-green-soft transition-colors"
        >
          Start Your Journey
        </a>
        <a
          href="/symptom-match"
          class="inline-block px-6 py-3 rounded-full bg-brand-hex text-brand-green font-medium hover:bg-brand-hex-deep transition-colors"
        >
          Manage Symptoms
        </a>
        <a
          href="/strains"
          class="inline-block px-6 py-3 rounded-full bg-brand-hex text-brand-green font-medium hover:bg-brand-hex-deep transition-colors"
        >
          View Strains
        </a>
      </div>
    </section>
  );
}
